import React, { useState, useRef } from 'react';
import { Card, CardContent } from './ui/card';
import { Play, Pause } from 'lucide-react';
import { Button } from './ui/button';

export default function VideoPlayer({ videoUrl, posterUrl, title }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  return (
    <Card className="bg-black/60 border-lime-500/30 backdrop-blur-sm">
      <CardContent className="p-6">
        <div className="max-w-2xl mx-auto space-y-4">
          <video
            ref={videoRef}
            className="w-full h-auto rounded-xl shadow-[0_0_40px_rgba(168,213,48,0.3)]"
            playsInline
            poster={posterUrl}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            onEnded={() => setIsPlaying(false)}
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
          
          {/* Bouton Play/Pause EN BAS - ne cache pas la vidéo */}
          <div className="flex items-center justify-center gap-4">
            <Button
              onClick={togglePlay}
              size="lg"
              className="bg-lime-500/90 hover:bg-lime-500 text-black shadow-lg shadow-lime-500/50 hover:shadow-lime-500/80 hover:scale-105 transition-all duration-300"
            >
              {isPlaying ? (
                <>
                  <Pause className="h-6 w-6 mr-2" />
                  <span className="text-lg font-bold">Pause</span>
                </>
              ) : (
                <>
                  <Play className="h-6 w-6 mr-2" />
                  <span className="text-lg font-bold">Play</span>
                </>
              )}
            </Button>
            
            {title && (
              <span className="text-sm text-gray-400">{title}</span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
